import localforage from "localforage";

import { LOCAL_STORAGE_KEYS } from "~/configs";

export const browserStorage = {
	token: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.TOKEN),
		set: (str: any) => localforage.setItem(LOCAL_STORAGE_KEYS.TOKEN, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.TOKEN),
	},
	companyId: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.COMPANY_ID),
		set: (str: any) => localforage.setItem(LOCAL_STORAGE_KEYS.COMPANY_ID, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.COMPANY_ID),
	},
	settings: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.SETTINGS),
		set: (str: any) => localforage.setItem(LOCAL_STORAGE_KEYS.SETTINGS, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.SETTINGS),
	},
	language: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.LANGUAGE),
		set: (str: any) => localforage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.LANGUAGE),
	},
	fileViewPreference: {
		get: () =>
			localforage.getItem<string>(LOCAL_STORAGE_KEYS.FILE_VIEW_PREFERENCE),
		set: (str: any) =>
			localforage.setItem(LOCAL_STORAGE_KEYS.FILE_VIEW_PREFERENCE, str),
		remove: () =>
			localforage.removeItem(LOCAL_STORAGE_KEYS.FILE_VIEW_PREFERENCE),
	},
	multiSelectButton: {
		get: () =>
			localforage.getItem<string>(LOCAL_STORAGE_KEYS.MULTI_SELECT_BUTTON),
		set: (str: any) =>
			localforage.setItem(LOCAL_STORAGE_KEYS.MULTI_SELECT_BUTTON, str),
		remove: () =>
			localforage.removeItem(LOCAL_STORAGE_KEYS.MULTI_SELECT_BUTTON),
	},
	searchButton: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.SEARCH_BUTTON),
		set: (str: any) =>
			localforage.setItem(LOCAL_STORAGE_KEYS.SEARCH_BUTTON, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.SEARCH_BUTTON),
	},
	fileSettings: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.FILE_SETTINGS),
		set: (str: any) =>
			localforage.setItem(LOCAL_STORAGE_KEYS.FILE_SETTINGS, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.FILE_SETTINGS),
	},
	dataDisplay: {
		get: () => localforage.getItem<string>(LOCAL_STORAGE_KEYS.DATA_DISPLAY),
		set: (str: any) =>
			localforage.setItem(LOCAL_STORAGE_KEYS.DATA_DISPLAY, str),
		remove: () => localforage.removeItem(LOCAL_STORAGE_KEYS.DATA_DISPLAY),
	},
};
